import React, { useEffect } from 'react';
import VendorList from './vendorList';
import $ from 'jquery';
import Ad from './ad';
import { LATER_FLAG, PROCESSED_FLAG } from '@nettbureau/kvittering-utils';

const moveProgressBar = ({ vendorList }) => {
  if (vendorList.length === 0) {
    return;
  }

  var getPercent = $('.order-receipt--progress-bar').data('progress-percent');
  var animationLength = 1500;
  $('.order-receipt--progress-bar-fill')
    .stop()
    .animate(
      {
        width: getPercent + '%',
      },
      animationLength
    );
};

const getLastStepStyles = (internalSales) => {
  return internalSales
    ? {
        marginTop: '20px',
        marginBottom: '20px',
      }
    : {};
};

const getFirstStepStyles = (internalSales) => {
  return internalSales
    ? {
        marginBottom: '20px',
      }
    : {};
};

const NoPartnersFound = ({ vendorList }) => {
  return vendorList.length === 0 ? (
    <div>
      <h1>Vi fant ingen leverandører</h1>
      <div className="order-receipt--alert">
        <p>
          Vi klarte dessverre ikke å finne en leverandør som passer dine behov. Vi inngår stadig nye samarbeid med
          ledende strømselskaper, og vil forhåpentligvis kunne gi deg et bedre tilbud i framtiden. Du kan gjerne prøve
          igjen om en stund.
        </p>
      </div>
    </div>
  ) : null;
};

const PartnersFound = ({ vendorList, internalSales }) => {
  return vendorList.length > 0 ? (
    <div>
      <h1>Snart i mål!</h1>
      <div className="order-receipt--progress-bar-wrap">
        <div className="order-receipt--progress-bar" data-progress-percent="90">
          <span className="order-receipt--progress-bar-fill"></span>
        </div>
      </div>
      <div className="order-receipt--steps">
        <div style={getFirstStepStyles(internalSales)} className="order-receipt--step order-receipt--step--partners">
          <div className="table table-block">
            <div className="table-cell cell-1-3 article-cell">
              <img alt="" src="https://luz.es/images/icons/luz-phone.svg" />
            </div>
            <div className="table-cell cell-2-3 article-cell">
              {internalSales === false && (
                <>
                  <h3>I løpet av 1-2 dager vil du bli kontaktet av disse selskapene:</h3>
                  <VendorList vendorList={vendorList}></VendorList>
                </>
              )}

              {internalSales && (
                <>
                  <h3>Du vil nå bli kontaktet av {vendorList[0].name}</h3>
                  <p style={{ fontSize: '17px' }}>
                    Da kan vi diskutere behovet ditt nærmere, og gi deg selskapenes mest konkurransedyktige tilbud.
                  </p>
                  <p style={{ fontSize: '17px' }}>
                    Vi kontakter deg så fort som mulig, noen ganger innen én time, og senest innen 1-2 dager.
                  </p>
                  <p style={{ fontSize: '17px' }}>
                    For å være helt sikker på at du mottar de gode tilbudene, bør du besvare telefonen i denne perioden.
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="table table-block">
          <div className="table-cell cell-1-3 article-cell"></div>
          <div className="table-cell cell-2-3 article-cell"></div>
        </div>
        <div style={getLastStepStyles(internalSales)} className="order-receipt--step">
          <div className="table table-block">
            <div className="table-cell cell-1-3 article-cell">
              <img alt="" src="https://luz.es/images/icons/luz-deal3.svg" />
            </div>
            <div className="table-cell cell-2-3 article-cell">
              <h3>
                {internalSales === false && (
                  <>
                    Du vil snart få <span className="order-receipt--hightlight">spesialtilbud</span> på strøm via
                    Strøm.no.
                  </>
                )}
                {internalSales && (
                  <>
                    Vi ringer deg fra telefonnummeret <span className="order-receipt--hightlight">919 29 268</span>.
                  </>
                )}
              </h3>
            </div>
          </div>
        </div>
      </div>
      {internalSales === false && (
        <div className="order-receipt--alert">
          <p>
            <strong>
              For å være helt sikker på at du mottar de gode tilbudene, bør du besvare ukjente telefonnummer i denne
              perioden!
            </strong>{' '}
            Merk at du av og til blir oppringt innen én time, men senest innen 1-2 dager.
          </p>
        </div>
      )}
      <Ad></Ad>
    </div>
  ) : null;
};

const LeadProcessedLater = (props) => {
  return (
    <div>
      ​<h1>Din henvendelse er mottatt!</h1>
      <div className="order-receipt--alert">
        <p>
          Din forespørsel behandles nå av opptil tre leverandører, som snart ringer med spesialtilbud til deg. Du vil
          straks få en e-post med mere info.
        </p>
      </div>
    </div>
  );
};

export default function (props) {
  const { loading, flag } = props;

  useEffect(() => moveProgressBar(props), [props]);

  return !loading && (flag === PROCESSED_FLAG || flag === LATER_FLAG) ? (
    <div>
      {flag === PROCESSED_FLAG && (
        <>
          <NoPartnersFound {...props}></NoPartnersFound>
          <PartnersFound {...props}></PartnersFound>
        </>
      )}

      {flag === LATER_FLAG && <LeadProcessedLater></LeadProcessedLater>}
    </div>
  ) : null;
}
